/*Slick v1.8.1 */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

  /* -- START Lightbox Javascript
    <script async type='text/javascript' src='https://www.lightboxcdn.com/vendor/cf4c0d14-9baa-4f1e-8669-13d5aa6a07bc/lightbox_inline.js'></script>
/* -- END Lightbox Javascript-- */

// If transperent
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header");
if(transperentElment){
  header.classList.add("allow-transparent-header");
}

//ordergroove app block shows only for US
var ordergrooveAppBlock = document.getElementById("shopify-block-ordergroove_subscriptions_smi_block_8UUqpR");
if(ordergrooveAppBlock){
  ordergrooveAppBlock.style.display = "none";

  var country_code = document.querySelector(".js").getAttribute("code");
  if (country_code == "US"){
    ordergrooveAppBlock.style.display = "block";
  }
}

//product page Subscription Block
document.addEventListener('DOMContentLoaded', function() {
  const deliverOptions = document.querySelector(".deliver-options");
  if(deliverOptions){
    deliverOptions.style.display = 'none';
  }
  
  var oneTimePurchase = document.querySelector(".app-select-block.regular-block og-optout-button");
  // console.log("oneTimePurchase",oneTimePurchase);
  if(oneTimePurchase){
    oneTimePurchase.addEventListener('click',function(){
      if (deliverOptions) {
        deliverOptions.style.display = 'none';
      }
    });
  }
  var subscriptionBlock = document.querySelector(".app-select-block.subscription-block og-optin-button");
  // console.log("subscriptionBlock",subscriptionBlock);
  if(subscriptionBlock){
    subscriptionBlock.addEventListener('click',function(){
      if (deliverOptions) {
          deliverOptions.style.display = 'block';
        }
    });
  }
  
});

//read more and read less description on product page
var readMorelink = document.querySelector(".read-more-link");
//console.log("readMorelink",readMorelink);
if(readMorelink){
  readMorelink.addEventListener('click',function(event){
    var fulldescription = document.getElementById("full-description");
     var halfdescription = document.getElementById("half-description");
    if(fulldescription.style.display === "none" || fulldescription.style.display === '' ){
      fulldescription.style.display = "block";
      halfdescription.style.display = "none";
      readMorelink.innerHTML = 'See Less Details';
    }else{
      fulldescription.style.display = "none";
      halfdescription.style.display = "block";
      readMorelink.innerHTML = 'See Full Details';
    }
  });
}

//product thumbnail arrow
var carouselPrevButton = document.querySelector(".carousel-prev-button");
var productThumbnails = document.querySelectorAll(".product-gallery__thumbnail");
productThumbnails.forEach(function(productThumbnail){
  var mediaPosition = productThumbnail.getAttribute("data-media-position");
  console.log("mediaPosition",mediaPosition);
  var ariacurrent = productThumbnail.getAttribute("aria-current");
  console.log("ariacurrent",ariacurrent);
  if(mediaPosition == 1 && ariacurrent == "true"){
     carouselPrevButton.setAttribute("disabled","disabled");
    //console.log("co0ndtion checked;;;;")
  }
});

var pdp_description = document.querySelector(".pdp_description");
if(pdp_description){
  console.log("pdp_description",pdp_description);
  pdp_description.addEventListener("click", function() {
    pdp_description.classList.toggle("active");
  });
}

$(document).ready(function(){
//quantity selector on mobile sticky bar and main
  var quantity = $(".quantity-selector__button").siblings(".quantity-selector__input").first().val();
  $(".icon-minus").click(function(e){
    var quantity = $(".quantity-selector__button").siblings(".quantity-selector__input").first().val();
    quantity--; 
    console.log("Quantity ",quantity)
    $(".sticky_quantity .quantity-selector__input").val(quantity);
  });
  $(".icon-plus").click(function(){
    var quantity = $(".quantity-selector__button").siblings(".quantity-selector__input").first().val();
    quantity++;
    console.log("Quantity",quantity);
    $(".sticky_quantity .quantity-selector__input").val(quantity);
  });

});


  //document.addEventListener('DOMContentLoaded', function () {
  //   const button = document.querySelector('.main-cart-button-new');
  //   const variantOptions = document.querySelectorAll('.variant_picker .ctm_opt');

  //   function updateButtonState($el) {
  //     const isAvailable = $el.dataset.available === 'true';
  //     const price = $el.dataset.price;

  //     if (!isAvailable || parseInt($el.dataset.inventory) <= 0) {
  //       button.textContent = 'Waitlist';
  //       button.disabled = true;
  //       button.classList.add('disabled');
  //     } else {
  //       button.textContent = `Add to cart - ${price}`;
  //       button.disabled = false;
  //       button.classList.remove('disabled');
  //     }
  //   }

  //   // On page load: check active variant
  //   const active = document.querySelector('.ctm_opt.active');
  //   if (active) {
  //     updateButtonState(active);
  //   }

  //   variantOptions.forEach(opt => {
  //     opt.addEventListener('click', function () {
  //       // Remove active from all
  //       variantOptions.forEach(o => o.classList.remove('active'));
  //       // Add active to clicked
  //       this.classList.add('active');

  //       // Update button state
  //       updateButtonState(this);
  //     });
  //   });
  // });
  
//Add 3 product to cart
// $(window).on("load", function () {
//   // Add all 3 products to cart ritual
//   var selector = $('button[type="button"].product-item__cta-all').length;
//   if (selector > 0) {
//     $('button[type="button"].product-item__cta-all').on("click", function () {
//       var arr = [];
//       var items = $(this).parent().find(".product_list_inner .product-card");
//       $(items).each(function (i, v) {
//         var id = $(v).find("form").find('input[name="id"]').val();
//         if(id != undefined) {
//           arr.push({ id: id, quantity:1});
//         }
//       });
//      let formData = {'items': arr};
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify(formData)
//         })
//         .then(response => response.json())
//         .then(response =>  {
//           this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true}));
//           var clickEvent = new MouseEvent('click', { bubbles: true,cancelable: true,view: window,});
//           document.getElementById('open-cart-drawer').dispatchEvent(clickEvent);
//         })
//     });
//   }
// });
  window.addEventListener("load", function () {
  const addAllBtn = document.querySelector('.shopify-section--related-products .product-item__cta-all');
  
  if (addAllBtn) {
    addAllBtn.addEventListener('click', function () {
      // Step 1: Find the closest <product-recommendations> to the clicked button
      const recommendationsBlock = addAllBtn.closest('product-recommendations');

      if (!recommendationsBlock) {
        console.warn('No <product-recommendations> found near the button.');
        return;
      }

      // Step 2: Query product cards only within this block
      const productCards = recommendationsBlock.querySelectorAll('.product-card');
      const itemsToAdd = [];

      productCards.forEach(card => {
        const form = card.querySelector('form');
        if (form) {
          const variantId = form.querySelector('input[name="id"]')?.value;
          if (variantId) {
            itemsToAdd.push({ id: variantId, quantity: 1 });
          }
        }
      });

      if (itemsToAdd.length > 0) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(response => response.json())
        .then(data => {
          // Trigger cart refresh event
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

          // Open cart drawer
          const cartDrawerTrigger = document.getElementById('open-cart-drawer');
          if (cartDrawerTrigger) {
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            });
            cartDrawerTrigger.dispatchEvent(clickEvent);
          }
        })
        .catch(error => {
          console.error('Error adding products to cart:', error);
        });
      }
    });
  }
});

// Recommendation Product in cart drawer
// $(document).on('click', '.related-product_list .addcart-btn',function(){
//     var pro_id = $(this).data("pro-id");
//     let arr = [];
//     arr.push({id: pro_id, quantity: 1 });
//     let formData = {'items': arr};
//     fetch('/cart/add.js', {
//       body: JSON.stringify(formData),
//       credentials: 'same-origin',
//       headers: {
//       'Content-Type': 'application/json',
//       'X-Requested-With':'xmlhttprequest'
//       },
//       method: 'POST'
//     }).then((response) => {
//     gtag('event', 'detailed_add_to_cart', {
//       'source': 'cart_recommendations'
//     });  
//     return response.json();
//     }).then((res) => {
//       this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true}));
//     }).catch((err) => {
//       console.error(err)
//     });
// });

$(document).on('click','.home-featured-product-wrapper .addcart-btn',function(){
  var product_id = $(this).data("product-id");
  let array = [];
  array.push({id: product_id, quantity: 1 });
  let formData = {'items': array};
   fetch('/cart/add.js', {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
    gtag('event', 'detailed_add_to_cart', {
      'source': 'home_featured_product'
    });   
    return response.json();
    }).then((res) => {
      this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true}));
      var clickEvent = new MouseEvent('click', { bubbles: true,cancelable: true,view: window,});
       document.getElementById('open-cart-drawer').dispatchEvent(clickEvent);
    }).catch((err) => {
      console.error(err)
    });
});

jQuery(".panel-inner h5").first().addClass("show");
jQuery(".panel .panel-inner").first().addClass("active");
jQuery(".planet-product").first().addClass("prdct_active");
jQuery(".panel-inner  h5").click(function () {
  if (jQuery(this).hasClass("show")) {
    jQuery(this).removeClass("show");
    jQuery(this).parent().removeClass("active");
    jQuery(this).next().slideUp();
  } else {
    jQuery(".panel-inner h5").removeClass("show");
    jQuery(".panel-inner").removeClass("active");
    jQuery(".panel-inner h5").next().slideUp();
    jQuery(this).addClass("show");
    jQuery(this).parent().addClass("active");
    jQuery(this).next().slideDown();
  }
});

$(".panel-inner > h5").click(function () {
  var data = $(this).parent().attr("data-id");
  //  var prdct = $('.planet-product').find(data);

  $(".about-planet .planet-product").each(function () {
    // Test if the div element is empty
    if ($(this).attr("data-id") == data) {
      jQuery(this).addClass("prdct_active");
    } else {
      jQuery(this).removeClass("prdct_active");
    }
  });
});
$(document).ready(function () {   
  $(".product_tab_wrapper ul li").click(function () {
    $(".product_tab_wrapper ul li").removeClass("active");
    $(this).addClass("active");
  });
  $(".slidebar-popup-btn").click(function () {
    $(this).addClass("active");
    $(".slidebar-overlay").addClass("active");
    $("body").addClass("slidebar_open");
  });
  $(".slidebar-overlay, .slidebar-popup-closeicon").click(function () {
    $(".slidebar-popup-btn").removeClass("active");
    $(".slidebar-overlay").removeClass("active");
    $("body").removeClass("slidebar_open");
  });
  $(".otherlinks_text_wrap li").mouseenter(function () {
    $(".otherlinks_text_wrap li").removeClass("active");
    $(this).addClass("active");
  });
  $(".header-sidebar_text_content_wrap li.mobile_menu_link").click(function () {
    $(this).toggleClass("active");
  });
  
  //On subscription option click change add to cart button price
  $("og-optout-button").click();
  $(".app-select-block.regular-block").click(function(){
    $(".subscription-price").addClass('disabled');
    if($(".regular-price").hasClass("disabled")){
      $(".regular-price").removeClass('disabled');
    }
  });
  $(".app-select-block.subscription-block").click(function(){
    $(".regular-price").addClass('disabled');
    if($(".subscription-price").hasClass("disabled")) {
      $(".subscription-price").removeClass('disabled');
    }
  });
  // Product Faqs Drawer
  $('.popup-contnet .faq-block').eq(0).addClass('active');
  $('.popup-contnet .faq-block').eq(0).find('.faq-title').addClass('active');
  $('.popup-contnet .faq-block .faq-title').click(function(){
    $('.popup-contnet .faq-block .faq-title').removeClass('active');
    $('.popup-contnet .faq-block').removeClass('active');
    $(this).toggleClass('active');
    $(this).parent().toggleClass('active');
    if ($(this).hasClass('active')){
      $(this).siblings().show();
    } else {
      $(this).siblings().hide();
    }
  });

   var $sunscreenproductList = $(".sunscreen-landing-page .featued-collection .product-list.product-list--carousel");
    var sunchange_slide_second = $sunscreenproductList.attr("data-seconds") * 1000;
    var sunautoplayDesktop = $sunscreenproductList.attr("desktop_checkbox") === "true";
    var sunautoplayMobile = $sunscreenproductList.attr("mobile_checkbox") === "true";

    $sunscreenproductList.slick({
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: sunautoplayDesktop, // Enable autoplay for desktop if checked
        autoplaySpeed: sunautoplayDesktop ? sunchange_slide_second : 0,
        prevArrow: ".slickslider-wrap .slick-prev-arrow",
        nextArrow: ".slickslider-wrap .slick-next-arrow",
        responsive: [
            {
                breakpoint: 1089, // Below 1089px (tablet/mobile view)
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: sunautoplayMobile, // Enable autoplay for mobile if checked
                    autoplaySpeed: sunautoplayMobile ? sunchange_slide_second : 0
                }
            },
            {
                breakpoint: 699, // Below 699px (mobile view)
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1,
                    autoplay: sunautoplayMobile,
                    autoplaySpeed: sunautoplayMobile ? sunchange_slide_second : 0
                }
            },
            {
                breakpoint: 575, // Below 575px (small mobile view)
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: sunautoplayMobile,
                    autoplaySpeed: sunautoplayMobile ? sunchange_slide_second : 0
                }
            }
        ]
    });

  // Home page featured-collection
    var $productList = $(".featued-collection .product-list");

    // Get autoplay settings from attributes
    var change_slide_second = $productList.attr("data-seconds") * 1000;
    var autoplayDesktop = $productList.attr("desktop_checkbox") === "true";
    var autoplayMobile = $productList.attr("mobile_checkbox") === "true";

    $productList.slick({
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: autoplayDesktop, // Enable autoplay for desktop if checked
        autoplaySpeed: autoplayDesktop ? change_slide_second : 0,
        prevArrow: ".slickslider-wrap .slick-prev-arrow",
        nextArrow: ".slickslider-wrap .slick-next-arrow",
        responsive: [
            {
                breakpoint: 1089, // Below 1089px (tablet/mobile view)
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: autoplayMobile, // Enable autoplay for mobile if checked
                    autoplaySpeed: autoplayMobile ? change_slide_second : 0
                }
            },
            {
                breakpoint: 699, // Below 699px (mobile view)
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1,
                    autoplay: autoplayMobile,
                    autoplaySpeed: autoplayMobile ? change_slide_second : 0
                }
            },
            {
                breakpoint: 575, // Below 575px (small mobile view)
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: autoplayMobile,
                    autoplaySpeed: autoplayMobile ? change_slide_second : 0
                }
            }
        ]
    });
  
});

//product page and home page testimonals silder
$(".product-testimonial_slider").slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 890,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 701,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".image_banner_collage_wrp").slick({
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 890,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 701,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
});
  
//Home Page Video with product slider js
$(".product_item_slider_wrap").each(function(){
  var itemToShow = $(this).data("item-to-show");
  console.log("itemToShow",itemToShow);

  $(this).slick({
    infinite: true,
    slidesToShow: itemToShow,
    slidesToScroll: 2,
    arrows:false,
    dots:false,
    centerMode:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode:false,
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode:false,
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode:false,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode:false,
        }
      }
    ]
  });
});

$('.product_video_slider.slick_true .product_video_card').slick({
  arrows:false,
  dots:true,
  adaptiveHeight: true
});


$('.collection-list-slider .collection-list').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  centerMode:true,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true
      }
    }
  ]
});

$('.rt-header').click(function(){
  var tab_id = $(this).attr('data-tab');
  $('.rt-header').removeClass('current');
  $('.rt-description').slideUp();
  $(this).addClass('current');
  $("#"+tab_id).slideDown();
});
$('.mobile-tab .mobile-tab-list').click(function(){
  var att_val =  $(this).attr('mobile-tabid');
  $('.mobile-tab .mobile-tab-list').removeClass('current');
  $(this).addClass('current');
  $('.rt-group .rt-row').each(function(){
    if(att_val == $(this).attr('mobile-tabid')){
      $('.rt-group .rt-row').removeClass('active');
      $(this).addClass('active');
    }
  });
  return false;
});

if (document.body.clientWidth < 700) {
  $(".shopify-section--image-with-text-overlay .content .prose .button").insertAfter(".shopify-section--image-with-text-overlay .content .prose");
} else { 
  $(".shopify-section--image-with-text-overlay .content .prose .button").insertAfter(".shopify-section--image-with-text-overlay .content .prose > div");
}
if (document.body.clientWidth < 769) {
  $(".home_product_slider.video_img-text-align_right .product_video_card h2").insertBefore(".home_product_slider.video_img-text-align_right .col.left-col .col-wrap");
} else { 
  $(".home_product_slider.video_img-text-align_right .product_video_card h2").insertBefore(".home_product_slider.video_img-text-align_right .block-dec");
};

if (document.body.clientWidth < 900) {
  $('.article_blog_posts_content').slick({
    infinite: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    centerMode:false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });
};

// Product royal-circle-banner
// document.addEventListener("DOMContentLoaded", function () {
//   const bind = () => {
//     $(".yotpo-product-points-widget .yotpo-product-points-widget-logged-out-view .yotpo-product-points-widget-link, .join-royal-circle-banner .join-royal-circle-banner-content .right-button").on("click", (e) => {
//       e.preventDefault();
      
//       $("#login-modal").show();
//       $("#login-modal, #login-modal .close").on("click", () => {
//         $("#login-modal").hide();
//       });
//       $("#login-modal .modal-content").on("click", function(e) {
//         e.stopPropagation();
//       });
//     });
//   };

//   bind();

//   let targetNode = document.querySelector("[data-yotpo-instance-id='736473']");
//   if (targetNode) {
//     let observer = new MutationObserver(bind);
//     let config = { attributes: true, childList: true, subtree: true, characterData: true };
//     observer.observe(targetNode, config);
//   }

//   document.addEventListener("yotpo:refreshed", bind);
// });

document.addEventListener("DOMContentLoaded", function () {
  const bind = () => {
    $(".join-royal-circle-banner .join-royal-circle-banner-content .right-button").on("click", (e) => {
      e.preventDefault();
      
      $("#login-modal").show();
      $("#login-modal, #login-modal .close").on("click", () => {
        $("#login-modal").hide();
      });
      $("#login-modal .modal-content").on("click", function(e) {
        e.stopPropagation();
      });
    });
  };

  bind();

  let targetNode = document.querySelector("[data-yotpo-instance-id='736473']");
  if (targetNode) {
    let observer = new MutationObserver(bind);
    let config = { attributes: true, childList: true, subtree: true, characterData: true };
    observer.observe(targetNode, config);
  }

  document.addEventListener("yotpo:refreshed", bind);
});



// Collection Variant Selector

// $(document).ready(function() {
//   // Delegated click for dynamically added elements
//   $(document).on('click', '.collection-variant-selector .selected', function(e) {
//     console.log("variant_click!!!");
//     e.stopPropagation();
//     const $parent = $(this).closest('.collection-variant-selector');
//     const $options = $parent.find('.options');

//     if ($parent.hasClass('open')) {
//       $parent.removeClass('open');
//       $('body').find('.colectioin-variant-selector-options').remove();
//     } else {
//       $('.collection-variant-selector').removeClass('open');
//       $('body').find('.colectioin-variant-selector-options').remove();

//       const offset = $(this).offset();
//       const height = $(this).outerHeight();

//       const $dropdownClone = $options.clone().addClass('colectioin-variant-selector-options');
//       $('body').append($dropdownClone);

//       $dropdownClone.css({
//         top: offset.top + height,
//         left: offset.left,
//         width: $options.outerWidth()
//       }).animate({ opacity: 1 }, 300);

//       $parent.addClass('open');

//       // Delegated click on cloned options
//       $dropdownClone.find('.option').on('click', function() {
//         const variantId = $(this).data('value');
//         const variantPrice = $(this).data('price');
//         const variantAvailable = $(this).data('available') === true || $(this).data('available') === "true";
//         const variantTitle = $(this).text().replace(/\s*\(Sold-Out\)/, '').trim();

//         $parent.find('.selected span').text(variantTitle);

//         const $input = $parent.closest('form').find('input[name="id"]');
//         $input.val(variantId).trigger('change');

//         const $addToCart = $parent.closest('form').find('button[type="submit"]');
//         $addToCart.prop('disabled', !variantAvailable);

//         const $paymentButton = $parent.closest('form').find('.shopify-payment-button');
//         if ($paymentButton.length) {
//           $paymentButton.toggle(variantAvailable);
//         }

//         $dropdownClone.remove();
//         $parent.removeClass('open');

//         $parent.find('.option').removeClass('selected');
//         $parent.find(`.option[data-value='${variantId}']`).addClass('selected');
//       });
//     }
//   });

  $(document).ready(function () {
    // Universal delegated click
$(document).on("click", ".collection-variant-selector .selected", function (e) {
  e.stopPropagation(); // Prevent closing search bar on select click

  const $parent = $(this).closest(".collection-variant-selector");
  const $options = $parent.find(".options");

  // Close if already open
  if ($parent.hasClass("open")) {
    $parent.removeClass("open");
    $(".colectioin-variant-selector-options[data-source='" + $parent.index() + "']").remove();
    return;
  }

  // Close all others
  $(".collection-variant-selector").removeClass("open");
  $(".colectioin-variant-selector-options").remove();

  const offset = $(this).offset();
  const height = $(this).outerHeight();

  // ✅ Detect if inside search popup
  const $searchContainer = $parent.closest(".header-search");
  const $container = $searchContainer.length ? $searchContainer : $("body");

  // ✅ Clone dropdown
  const $dropdownClone = $options
    .clone()
    .addClass("colectioin-variant-selector-options")
    .attr("data-source", $parent.index());

  // ✅ Append inside the correct container
  $container.append($dropdownClone);

  $dropdownClone.css({
    top: offset.top + height - ($searchContainer.length ? $searchContainer.offset().top : 0),
    left: offset.left - ($searchContainer.length ? $searchContainer.offset().left : 0),
    width: $options.outerWidth(),
    position: "absolute",
    zIndex: 9999,
  }).animate({ opacity: 1 }, 200);

  $parent.addClass("open");

  // ✅ Prevent closing when clicking inside dropdown
  $dropdownClone.on("click", function (e) {
    e.stopPropagation();
  });

  // ✅ Option select
  $dropdownClone.find(".option").off("click").on("click", function (e) {
    e.stopPropagation(); // Prevent outside click close

    const variantId = $(this).data("value");
    const variantAvailable = $(this).data("available") === true || $(this).data("available") === "true";
    const variantTitle = $(this).text().replace(/\s*\(Sold-Out\)/, "").trim();

    $parent.find(".selected span").text(variantTitle);

    let $card = $parent.closest("buy-buttons, .horizontal-product-card, .horizontal-product-card-variant");
    let $input = $card.find("input[name='id']");

    if (!$input.length) {
      $input = $("form.product-form input[name='id']");
    }

    $input.val(variantId).trigger("change");

    const $form = $parent.closest("form");
    const $inputs = $form.find("input[name='id']");
    if ($inputs.length) {
      $inputs.val(variantId).trigger("change");
    }

    $form.find("button[type='submit']").prop("disabled", !variantAvailable);
    $form.find(".shopify-payment-button").toggle(variantAvailable);

    let $addToCart = $card.find("button[type='submit'], a.button");
    $addToCart.prop("disabled", !variantAvailable);

    const $paymentButton = $card.find(".shopify-payment-button");
    if ($paymentButton.length) {
      $paymentButton.toggle(variantAvailable);
    }

    $dropdownClone.remove();
    $parent.removeClass("open");

    $parent.find(".option").removeClass("selected");
    $parent.find(`.option[data-value='${variantId}']`).addClass("selected");
  });
});

    // Click outside → close all
    $(document).on("click", function () {
      $(".collection-variant-selector").removeClass("open");
      $(".colectioin-variant-selector-options").remove();
    });
  });


  // Close dropdown when clicking outside
  // $(document).on('click', function() {
  //   $('.collection-variant-selector').removeClass('open');
  //   $('body').find('.colectioin-variant-selector-options').remove();
  // });

  //   document.querySelectorAll('.collection-variant-selector .option').forEach(option => {
  //   option.addEventListener('click', function() {
  //     const variantId = this.dataset.value; // selected variant ID
  //     const formInput = this.closest('.horizontal-product-card-variant').querySelector('.product-variant-id');
  //     formInput.value = variantId; // update hidden input

  //     // Update the selected label text
  //     const selectedLabel = this.closest('.collection-variant-selector').querySelector('.selected span');
  //     selectedLabel.textContent = this.textContent.trim();

  //     // Mark selected option visually
  //     this.parentElement.querySelectorAll('.option').forEach(opt => opt.classList.remove('selected'));
  //     this.classList.add('selected');
  //   });
  // });



    //   $dropdownClone.on('click', '.option', function () {
    //   const $this = $(this);
    //   const isMobile = window.matchMedia("(max-width: 768px)").matches;
    
    //   $parent.find('.selected > span').html($this.text());
    //   $input.val($this.data("value"));
    //   $priveRange.html($this.data("price"));
    
    //   const isAvailable = $this.data("available") === true || $this.data("available") === "true";
    //   const waitlistText = $this.data("waitlist") || "Sold Out";
    //   const dataUrl = $this.data("url");
    
    //   const forceWaitlist = $this.data("force-waitlist") === true || $this.data("force-waitlist") === "true";
    
    //   const $button = $parent.next('.main-cart-button-new');
    //   $button.off('click.waitlist'); // remove any previous handler
    
    //   if (!isAvailable || forceWaitlist) {
    //     console.log("Waitlist mode activated");
    //     $button.find('.text').text(waitlistText);
    //     $button.removeAttr('disabled');
    
    //     if (dataUrl) {
    //       $button.on('click.waitlist', function (e) {
    //         e.preventDefault();
    //         window.location.href = dataUrl;
    //       });
    //     }
    //     else{
          
    //     }
    //   } else {
    //     $button.find('.text').text(isMobile ? "Add" : "Add to cart");
    //     $button.removeAttr('disabled');
    //   }
    
    //   $parent.removeClass('open');
    //   $dropdownClone.remove();
    // });

//     }
//   })
// });

// window.addEventListener('DOMContentLoaded', () => {
//   setTimeout(() => {
//     document.querySelectorAll('.product-card .collection-variant-selector').forEach((selector, i) => {
//       const card = selector.closest('.product-card');
//       const firstOption = selector.querySelector('.option');
//       if (!firstOption) return;

//       const forceWaitlist = firstOption.dataset.forceWaitlist === "true";
//       if (forceWaitlist) {
//         console.log("firstOption", firstOption);
//         $(firstOption).trigger('click');
//       }
//     });
//   }, 300); 
// });


// document.querySelector('.form-control:nth-child(3) input').addEventListener('focus', function() {
//     this.placeholder = '';
// });

// document.querySelector('.form-control:nth-child(3) input').addEventListener('blur', function() {
//     this.placeholder = 'dd/mm/yyyy';
// });

document.addEventListener("DOMContentLoaded", function () {
    const drawerBody = document.querySelector(".drawer::part(body)");
    const scrollButton = document.querySelector(".cart-scroll-button");

    if (drawerBody) {
        drawerBody.addEventListener("scroll", function () {
            if (drawerBody.scrollHeight - drawerBody.scrollTop <= drawerBody.clientHeight + 1) {
                scrollButton.style.display = "none";
            } else {
                scrollButton.style.display = "block";
            }
        });
    }
});

if($('product-sticky-bar').length > 0){
 $('.ctm_opt.active').click(); 
}


document.addEventListener("click", function (event) {
  if (event.target.classList.contains("main_tab_trigger")) {
    var tab_data = event.target.getAttribute("data_handle");

    document
      .querySelectorAll(".main_tab_trigger")
      .forEach(function (element) {
        element.classList.remove("active");
        element.classList.add("inactive");
      });

    event.target.classList.add("active");
    event.target.classList.remove("inactive");

    document
      .querySelectorAll(".tab-info[data_handle]")
      .forEach(function (element) {
        element.classList.add("hidden");
        element.classList.remove("active");
        element.classList.add("inactive");
      });

    var targetTab = document.querySelector(
      '.tab-info[data_handle="' + tab_data + '"]'
    );
    if (targetTab) {
      targetTab.classList.add("active");
      targetTab.classList.remove("active", "inactive");
      targetTab.classList.remove("hidden");
    }
  }
});

if (document.body.clientWidth < 750) {
    const lastCollage = document.querySelector(".product-info__block-item.review-variant-price");
    const collageSecond = document.querySelector(".product-info__block-item.title");
    const lastCollage_2 = document.querySelector(".product-info__block-item.slidebar");
    const collageSecond_2 = document.querySelector(".product-info__block-item.description");
    const lastCollage_3 = document.querySelector(".product-info__block-item.variant-picker");
    const lastCollage_4 = document.querySelector(".product-info__block-item.skio-plan-picker");
    const lastCollage_5 = document.querySelector(".product-info__block-item.buy-buttons");

    const product_features_list = document.querySelector(".product_features_list");
    const complementary = document.querySelector(".product-info__block-item.complementary-products");

    if (lastCollage && collageSecond) {
        lastCollage.after(collageSecond);
    }
    // if (lastCollage_2 && collageSecond_2) {
    //     lastCollage_2.after(collageSecond_2);
    // }
    if (lastCollage_3 && collageSecond) {
        collageSecond.after(lastCollage_3);
    }
    if (lastCollage_3 && collageSecond) {
        collageSecond.after(lastCollage_3);
    }
    if (lastCollage_3 && lastCollage_4) {
        lastCollage_3.after(lastCollage_4);
    }
    if (lastCollage_5 && lastCollage_4) {
        lastCollage_4.after(lastCollage_5);
    }

    if (product_features_list && complementary) {
        complementary.before(product_features_list);
    }
}



// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");

    if (intro) {
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((a) => closeAccordion(a));
          openAccordion(e.target.closest("[js-acc-item]"));
        }
      };
    }
  });
}

document.addEventListener("DOMContentLoaded", faq_taggol);
document.addEventListener("DOMContentLoaded",function(){
  const button = document.querySelector(".featured-product-button-wrapper .addcart-btn");
  if(button){
    button.addEventListener('click',function(){
      const varinatId = button.getAttribute("data-product-id");
      var arr = [];
      
        
            arr.push({ id: varinatId, quantity:1});
          

      let formData = {'items': arr};
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(response =>  {
            this.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true}));
            var clickEvent = new MouseEvent('click', { bubbles: true,cancelable: true,view: window,});
            document.getElementById('open-cart-drawer').dispatchEvent(clickEvent);
          })
    });
  }
});
// document.addEventListener("DOMContentLoaded",function(){
//   const option_values = document.querySelectorAll(".variant-picker .option-elem");
//   if(option_values.length){
//     option_values.forEach((option_value)=>{
//       option_value.addEventListener('click',function(){
//         console.log("clicked..");

//         option_values.forEach((elem)=>{
//           elem.classList.remove('active');
//         })
//         this.classList.add('active');
//       });
//     });
//   }
  
// });



